import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const DailyReportLayout = (props: Props) => {
    return (
        <><Outlet /></>
    );
};

export default DailyReportLayout;